import { Asset } from '../v2/components/Asset'
import Text from './ui/text'
import { Asset as AssetType } from '@telesoft/types/payload-types'
import cn from 'classnames'
import React, { ReactElement } from 'react'
import { RichText } from '../v2/components/RichText'

interface Props {
  idx: number
  title: string
  description: string
  background?: string
  image: AssetType
}

export default function FeatureGridItem({
  idx,
  title,
  description,
  background,
  image,
}: Props): ReactElement {
  const renderImage = () => {
    if (image) {
      return (
        <div className="absolute h-12 w-12 top-3 right-3 z-20">
          <Asset fill resource={image} />
        </div>
      )
    }
    return ''
  }
  return (
    <div
      key={idx}
      className={cn(
        `group relative duration-300 p-6 md:p-8 lg:p-12 col-span-full md:col-span-4 lg:col-span-4 border-heading flex flex-col justify-start items-stretch`,
      )}
      style={{ backgroundColor: `${background}` }}
    >
      {renderImage()}
      <Text variant="heading" className="text-black" style={{ fontSize: '1.25rem' }}>
        {title}
      </Text>
      {description && (
        <Text variant="body" className="text-black mt-4">
          <RichText content={description} />
        </Text>
      )}
    </div>
  )
}
